module.exports = __webpack_public_path__ + "media/images/flags/16/Serbia-54f6431b5fba7bc0d66092512912bec7.png";